import { Box, IconButton, styled } from '@mui/material';
import { grey } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  transition: `background-color 0.4s ${theme.transitions.easing.easeInOut}`,
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.black, 0.3),
  },
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),
  justifyContent: 'center',
  alignItems: 'center',
}));

export const RemoveImageButton = styled(IconButton)(({ theme: { palette } }) => ({
  backgroundColor: palette.action.active,
  '&:hover': { backgroundColor: palette.text.primary },
  '& svg': { color: palette.common.white, '& path': { fill: palette.common.white } },
}));

export const StyledImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: grey[100],
}));

export const StyledTabButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
}));

export const BigIconWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
}));

export const StyledEmptyUploaderContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const StyledUploadedImageContainer = styled(Box)(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  cursor: 'default',
  overflow: 'hidden',
}));
